module.exports = __webpack_public_path__ + "img/yuebao.6fe8b1a7.png";